<script setup>
import { computed } from 'vue';
import { useStore, useMapGetter } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { frontendURL } from 'dashboard/helper/URLHelper';
import { ref } from 'vue';
import CsmlVisualBuilder from '../components/visualBuilder/CsmlVisualBuilder.vue';

const builderRef = ref(null);
const store = useStore();
const { t } = useI18n();
const router = useRouter();
const uiFlags = useMapGetter('agentBots/getUIFlags');
const accountId = computed(() => store.getters.getCurrentAccountId);

const isSaving = computed(() => uiFlags.value.isCreating);

const goBack = () => {
  router.push(frontendURL(`accounts/${accountId.value}/settings/agent-bots`));
};

const saveBot = async botData => {
  try {
    await store.dispatch('agentBots/create', {
      ...botData,
      outgoing_url: '',
    });
    useAlert(t('AGENT_BOTS.VISUAL_BUILDER.TOAST.SAVE_SUCCESS'));
    builderRef.value?.markSaved();
    goBack();
  } catch (_) {
    useAlert(t('AGENT_BOTS.VISUAL_BUILDER.TOAST.SAVE_ERROR'));
  }
};
</script>

<template>
  <div class="h-full w-full">
    <CsmlVisualBuilder
      ref="builderRef"
      mode="create"
      :is-saving="isSaving"
      @save="saveBot"
      @cancel="goBack"
    />
  </div>
</template>
